import { Box, Column, Grid } from 'lmc-ui-library';
import { Heading, Text, Button } from 'lmc-ui-library-rebrand';
import React, { useState } from 'react';

import { Layouts, PageLayoutParams } from 'layouts/LayoutProvider';
import { PageComponentProps } from 'shared/interface/globalInterface';

import { resendVerificationEmailWithToken } from '../../api';
import Template from '../../components/Template/Template';
import { ButtonsContainer } from './Verification.styled';
import Progress from 'screens/BrokerPortal/screens/Registration/components/Progress/Progress';
import { Step } from 'screens/BrokerPortal/screens/Registration/steps';
import styles from './Verification.module.scss';

interface Props extends PageComponentProps {}

const Verification: React.FC<Props> & PageLayoutParams = ({ match }) => {
  const [isEmailSent, setIsEmailSent] = useState<boolean>(false);

  const { token } = match.params;

  const handleClick = async (token: string) => {
    await resendVerificationEmailWithToken(token);
    setIsEmailSent(true);
  };

  return (
    <Template>
      <>
        <Progress currentStep={Step.VERIFICATION} />
        <Box>
          <Box.Content className={styles.verificationBox}>
            <Grid cols={12}>
              <Column lg={10} md={10} sm={12} xs={12}>
                <Heading mode="title" weight="bold">
                  Thanks for registering. Please verify your email and set your password
                </Heading>
                <Text color="var(--color-indigo-t11)">
                  We have sent you an activation link in an email. You will need to click this so that you can set your
                  password and access the portal. If this has not been received within one hour, please check your junk
                  email folder. If you have still not received it, you can request a new link below or contact us at{' '}
                  <a href="mailto: sales@livemoremortgages.com">sales@livemoremortgages.com</a> or{' '}
                  <a href="tel:020 4525 7754">020 4525 7754</a> to request a new link.
                </Text>
                <ButtonsContainer>
                  <Button
                    borderVariant="rectangle"
                    mode="ghost"
                    style={{ fontWeight: 'bold' }}
                    disabled={isEmailSent}
                    onClick={() => handleClick(token)}>
                    {isEmailSent ? 'Email sent' : 'Resend email'}
                  </Button>
                </ButtonsContainer>
              </Column>
            </Grid>
          </Box.Content>
        </Box>
      </>
    </Template>
  );
};

Verification.layout = Layouts.REGISTRATION;

export default Verification;
